import { render, staticRenderFns } from "./CognitiveZJCX.vue?vue&type=template&id=38f30457&scoped=true"
import script from "./CognitiveZJCX.vue?vue&type=script&lang=js"
export * from "./CognitiveZJCX.vue?vue&type=script&lang=js"
import style0 from "./CognitiveZJCX.vue?vue&type=style&index=0&id=38f30457&prod&scoped=true&lang=css"
import style1 from "./CognitiveZJCX.vue?vue&type=style&index=1&id=38f30457&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f30457",
  null
  
)

export default component.exports